export function isURLApi(error) {
  const url = error.response.request.responseURL
  return url.startsWith('https://api')
}
